// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/kpi-header/kpi-element/kpi-element.less
// module id = 3345
// module chunks = 0